var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpValidation } from "../validation/HttpValidation";
import { TokenInterceptor } from "../interceptors/TokenInterceptor";
/**
 * Classe resposável por fazer comunicação Rest
 */
export class Quark {
    get validation() {
        return this._validation;
    }
    set validation(validation) {
        this._validation = validation;
    }
    get request() {
        return this._request;
    }
    set request(request) {
        this._request = request;
    }
    get response() {
        return this._response;
    }
    set response(response) {
        this._response = response;
    }
    constructor(request, response) {
        this._validation = new HttpValidation();
        this._request = request;
        this._response = response;
    }
    //Chamada da comunicação, retornando a construção do Response
    call() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.validation.validate(this.request)) {
                return { code: -1, message: this.validation.messageValidation.message };
            }
            if (this.request.header)
                TokenInterceptor.insertToken(this.request.header);
            return yield this.response.buildResponse(this.request);
        });
    }
}
